import styled, { keyframes } from "styled-components";
import { Badge } from "antd";

const beatingKeyFrame = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
`;

const BeatingContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: 3s ${beatingKeyFrame} infinite;
`;

const NumberBadge = styled(Badge)`
  .ant-badge-count {
    background-color: ${(props) => props.theme.colors.primary};
  }
  margin-right: 5px;
`;

const Container = styled.div`
  padding: 20px;
  overflow-y: scroll;

  .ant-table-content {
    overflow-x: scroll;
  }

  .ant-table-thead .ant-table-cell {
    background-color: white;
    color: #8c8c8c;
    font-weight: 600;
  }
`;

export { BeatingContainer, NumberBadge, Container };
